import React from 'react';
import {Box, Container, Stack, Typography} from '@mui/material';

const HowToParticipate: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{py: {xs: 6, md: 8}}}>
            <Stack>
                <Typography
                    variant="h2"
                    sx={{
                        fontSize: {xs: '2.5rem', md: '4rem'},
                        fontWeight: 700,
                        textAlign: 'center',
                        mb: {xs: 4, md: 6},
                        fontFamily: 'Kyiv Type Serif'
                    }}
                >
                    Як взяти участь у KMA Winter School?
                </Typography>

                <Stack
                    direction={{xs: 'column', md: 'row'}}
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={4}
                >
                    <Box
                        component="img"
                        src="howto/podil.webp"
                        alt=""
                        sx={{
                            width: {sm: '100%', md: '60%'},
                            height: 'auto',
                            objectFit: 'cover',
                            borderRadius: 2
                        }}
                    />

                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, flex: {md: 3}}}>
                        <Box>
                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: '1.125rem',
                                    mb: 1,
                                    overflowWrap: 'break-word'
                                }}
                            >
                                1. Заповніть <a style={{color: '#062159', textDecoration: 'underline', fontWeight: '600'}}
                                                href="https://forms.office.com/e/X3yd36cNkk">анкету</a> до 21 грудня
                            </Typography>
                            <Typography
                                sx={{
                                    color: 'text.secondary',
                                    fontSize: '0.875rem',
                                    ml: 3,
                                    overflowWrap: 'break-word'
                                }}
                            >
                                Для уточнення додаткових деталей кандидатам може бути призначена співбесіда
                            </Typography>
                        </Box>

                        <Box>
                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: '1.125rem',
                                    mb: 1,
                                    overflowWrap: 'break-word'
                                }}
                            >
                                2. Дочекайтеся відповіді від нас
                            </Typography>
                            <Typography
                                sx={{
                                    color: 'text.secondary',
                                    fontSize: '0.875rem',
                                    ml: 3,
                                    overflowWrap: 'break-word'
                                }}
                            >
                                Опрацювання анкет до 23 грудня
                            </Typography>
                        </Box>

                        <Typography
                            sx={{
                                fontFamily: 'Kyiv Type Sans',
                                fontSize: '1.125rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                overflowWrap: 'break-word'
                            }}
                        >
                            3. Отримайте підтвердження участі
                        </Typography>

                        <Typography
                            sx={{
                                fontFamily: 'Kyiv Type Sans',
                                fontSize: '1.125rem',
                                mt: 2,
                                overflowWrap: 'break-word',
                                fontWeight: '600'
                            }}
                        >
                            Що ж далі?
                        </Typography>

                        <Typography
                            sx={{
                                fontFamily: 'Kyiv Type Sans',
                                fontSize: '1.125rem',
                                overflowWrap: 'break-word'
                            }}
                        >
                            4. Установча зустріч KMA Winter School із батьками або відповідальними особами
                        </Typography>

                        <Typography
                            sx={{
                                fontFamily: 'Kyiv Type Sans',
                                fontSize: '1.125rem',
                                overflowWrap: 'break-word'
                            }}
                        >
                            5. Початок KMA Winter School
                        </Typography>
                    </Box>
                </Stack>
            </Stack>
        </Container>
    );
};

export default HowToParticipate;